import { MenuList, styled } from '@mui/material';
import { CoreMenuItem } from '@youscience/core';

export const StyledScholarshipCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '2rem',
  marginTop: '2.5rem',

  [theme.breakpoints.up('md')]: {
    justifyContent: 'start',
  },
}));

export const StyledPageFiltersWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  position: 'relative',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const StyledFilterChipsWrap = styled(MenuList, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color, theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  gap: '0.25rem',
  margin: '1rem 0',

  'li.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: color,
    opacity: 0.8,

    '&:hover': {
      cursor: 'default',
      backgroundColor: color,
      opacity: 0.8,
    },
  },

  [theme.breakpoints.up('sm')]: {
    margin: 0,
    gap: '0.75rem',
    position: 'absolute',
    top: '-0.5rem',
    left: '44%',
  },

  [theme.breakpoints.up('md')]: {
    left: '34%',
    top: '-0.5rem',
  },
}));

export const StyledFilterItem = styled(CoreMenuItem, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color, theme }) => ({
  height: '32px',
  minHeight: 'auto',
  padding: '0 0.625rem',
  fontSize: '0.875rem',
  color,
  border: `1px solid ${color}`,
  borderRadius: '1rem',

  '&:hover': {
    color: theme.palette.common.white,
    backgroundColor: color,
    opacity: 0.5,
  },
}));
